import React from 'react';
import {
  planIcon0,
  planIcon1,
  planIcon2,
  planIcon3,
  planIcon4,
  planIcon5,
} from '../../assets/icons';
import './style.less';

const CAPABILITIES = [
  {
    domain: '研发工作',
    icon: planIcon0,
    title: '多形态云端工作间与独立存储卷',
    desc: '基于统一 Ubuntu 24.04 底座，官方提供终端、VS Code、JupyterLab、IntelliJ IDEA 及五大语言栈（Java / Go / Node / C++ / Python 数据科学）。',
    bullets: [
      '浏览器 Web IDE 与本地 VS Code / JetBrains Gateway 双模连接',
      '家目录 /home/workspace 独立持久化存储卷，支持跨工作间挂载迁移',
      '同源路径端口转发，单域名单证书直接预览 Web 应用服务',
    ],
  },
  {
    domain: 'AI 辅助研发',
    icon: planIcon1,
    title: '原生双 AI 智能体与企业模型网关',
    desc: '工作间主容器预装 Codex 与 Steerable，直接调用容器内 JDK、Maven、GCC 等编译测试工具链，开箱即用。',
    bullets: [
      '统一模型网关支持 OpenAI Responses 与 Chat Completions 流式协议',
      '上游 API Key 仅存控制面，工作间按专属 gct_ 令牌隔离调用',
      '内置连通性、流式输出与工具调用三项检测，支持项目级模型白名单与额度',
    ],
  },
  {
    domain: '项目治理',
    icon: planIcon2,
    title: '多项目安全边界与外包限期授权',
    desc: '以项目作为核心资源、数据与权限隔离边界，平台角色与项目角色严格分离，专为集团多项目与外包协同设计。',
    bullets: [
      '外包负责人提名、集团项目负责人审批的甲乙双方职责分离机制',
      '账号、项目成员与临时例外均强制绑定有效期，到期自动撤权断连',
      '人员退场时工作间与存储卷支持一键移交、归档或销毁处置',
    ],
  },
  {
    domain: '安全合规',
    icon: planIcon3,
    title: '五层数据防泄漏（DLP）与动态水印',
    desc: '按「平台 → 项目 → 项目角色 → 个人 → 审批例外」五层策略合并，同一控制项遵循禁止优先原则，严防源码外流。',
    bullets: [
      '细粒度管控文件下载、剪贴板复制/剪切与 SSH 远程接入开关',
      '禁止远程接入或吊销 SSH 公钥后，存量会话在 60 秒内强制断开',
      'Web IDE / 控制台 / Dev URL 覆盖防删改斜向动态水印，支持单向拖拽上传',
    ],
  },
  {
    domain: '插件生态',
    icon: planIcon4,
    title: '私有插件市场与标准化环境模板',
    desc: '内置企业级私有插件市场，打通纯内网离线环境下的插件供给、安全扫描、人工审核与项目白名单管控。',
    bullets: [
      '支持 .gcpb 签名离线插件包导入与 OSV 离线漏洞公告扫描',
      '严格遵循草稿 → 待审核 → 上架/驳回状态流转，阻断高危插件入库',
      '项目负责人将镜像、规格与插件固化为共享模板，团队成员一键复用',
    ],
  },
  {
    domain: '资源运维 & 平台治理',
    icon: planIcon5,
    title: '多集群调度、镜像合规与效能度量',
    desc: '控制面与工作集群解耦，内置 16 项镜像安全规范校验与漏洞门禁，全方位观测算力水位与研发效能。',
    bullets: [
      '支持多 K8s 工作集群接入、构建/工作命名空间网络隔离与节点污点调度',
      '空闲工作间自动挂起（默认 24h）与超期销毁（默认 30d），自动回收算力',
      '实时采集 CPU/内存/磁盘历史曲线，按自然日统计活跃度与 Web IDE 专注度',
    ],
  },
];

const FeatureGrid = () => {
  return (
    <div className="feature-grid">
      {CAPABILITIES.map((item) => (
        <article key={item.title} className="feature-card cloud-collab-card">
          <div className="card-top">
            <div className="feature-icon">
              <img src={item.icon} alt="" aria-hidden="true" />
            </div>
            <span className="domain-tag">{item.domain}</span>
          </div>

          <h3>{item.title}</h3>
          <p className="feature-desc">{item.desc}</p>

          <ul className="feature-bullets">
            {item.bullets.map((bullet) => (
              <li key={bullet}>
                <span className="check-mark" aria-hidden="true">✓</span>
                <span>{bullet}</span>
              </li>
            ))}
          </ul>
        </article>
      ))}
    </div>
  );
};

export default FeatureGrid;
